import React from 'react';
import styled from 'styled-components';
import { SpH5, SpText } from 'components/DesignKit';
import moment from 'moment-timezone';
import {
  Icon,
  Timeline,
  Row,
  Col,
} from 'antd';

type Props = {
  selectedAccount: Object,
  timelineDetail: Object,
};

const ColoredTimelineItem = styled(Timeline.Item)`
  .ant-timeline-item-tail {
    border-left: 2px
      ${({ lineStyle }) => lineStyle || 'solid'}   /* solid | dashed | dotted */
      ${({ lineColor }) => lineColor || '#d9d9d9'} !important;
  }
`;

const ActivityLogTimeline = (props: Props) => {
  const {
    selectedAccount,
    timelineDetail,
  } = props;

  const formatDate = (date) => {
    if (selectedAccount && selectedAccount.timezone) {
      return moment
        .utc(date)
        .tz(selectedAccount.timezone)
        .format('MMM DD, YYYY, hh:mm a');
    }
    return '';
  };

  const DoneIcon = <Icon type="check-circle" style={{ color: 'green', fontSize: 20 }} />;

  return (
    <Timeline>
      {
        timelineDetail?.map((step, key) => (
          <ColoredTimelineItem
            lineColor="green"
            color="green"
            dot={DoneIcon}
            key={key}
          >
            <Row>
              <SpH5>{step.eventHeader}</SpH5>
            </Row>
            {
              step.eventActions.map((eventAction, eventActionKey) => (
                <Row key={eventActionKey}>
                  <Col>
                    <SpText>{eventAction}</SpText>
                  </Col>
                </Row>
              ))
            }
            <Row>
              <Col>
                <SpText>{formatDate(step.eventTime)}</SpText>
              </Col>
            </Row>
            {
              step.eventOrigin && (
                <Row>
                  <Col>
                    <SpText>Page: {step.eventOrigin}</SpText>
                  </Col>
                </Row>
              )
            }
            {
              step.eventDetails && (
                step.eventDetails.map((unitAction, unitActionKey) => (
                  <Row key={unitActionKey}>
                    <Col>
                      <SpText>{unitAction.eventText}</SpText>
                    </Col>
                  </Row>
                ))
              )
            }
          </ColoredTimelineItem>
        ))
      }
    </Timeline>
  );
};

export default ActivityLogTimeline;
